import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { DineRewardsClient } from './client';
import { store } from '../../../lib/store/Store';
import { RequestClaimMissingPointsDTO } from '../../entities/MissingPointsFormsDTO';
import { AccountRegisterInfo } from '../../entities/AccountRegisterInfo';

export const DineRewardsService = {
	GetAllStores: async (): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/allStores`,
		});
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetAccountInfo: async (phoneNumber: string): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/users/phone/${phoneNumber}/account`,
		});
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetAccountInfoByEmail: async (email: string): Promise<RestResponse> => {
		const auth0Token = store.getState().app.auth0Token;

		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/users/email/${email}/account`,
		});
		if (auth0Token) {
			request.headers = {
				authorization: `Bearer ${auth0Token}`,
			};
		}
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetTransactionHistoryByEmail: async (email: string): Promise<RestResponse> => {
		const auth0Token = store.getState().app.auth0Token;

		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/transactions/${email}/history`,
		});
		if (auth0Token) {
			request.headers = {
				authorization: `Bearer ${auth0Token}`,
			};
		}
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetAccountHistoryByPhoneNumber: async (phoneNumber: string): Promise<RestResponse> => {
		const auth0Token = store.getState().app.auth0Token;

		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/loyaltyusers/${phoneNumber}/history`,
		});
		if (auth0Token) {
			request.headers = {
				authorization: `Bearer ${auth0Token}`,
			};
		}
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetActivityTimeline: async (loyaltyAccountNumber: string): Promise<RestResponse> => {
		const auth0Token = store.getState().app.auth0Token;

		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/loyalty/transactionforcard/${loyaltyAccountNumber}/timeline`,
		});
		if (auth0Token) {
			request.headers = {
				authorization: `Bearer ${auth0Token}`,
			};
		}
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetProfanityCheck: async (firstName: string, lastName: string): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/translationwrapper/issan?name=${firstName}&lastname=${lastName}`,
		});
		return await DineRewardsClient.ExecuteRequest(request);
	},
	GetGDPRExtensions: async (): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/translationwrapper/gdpr_email_extensions`,
			headers: {
				'x-mav-cache': 2_000_000,
			},
		});
		return await DineRewardsClient.ExecuteRequest(request);
	},
	PostEditAccountInfo: async (info: AccountRegisterInfo) => {
		const auth0Token = store.getState().app.auth0Token;

		const request = new RestRequest({
			method: HttpMethods.Post,
			endpoint: `/loyalty/EditAccount`,
			body: { ...info },
		});
		if (auth0Token) {
			request.headers = {
				authorization: `Bearer ${auth0Token}`,
			};
		}
		return await DineRewardsClient.ExecuteRequest(request);
	},
	ClaimMissingPoint: async (payload: RequestClaimMissingPointsDTO): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Post,
			endpoint: `/loyalty/v2/orders/claim`,
			body: payload,
		});
		return await DineRewardsClient.ExecuteRequest(request);
	},
} as const;
